// Form utils
const { $ } = window;

$(() => {
  $('.clear-input').on('click', function callback() {
    $(this).parent().find('input').val('')
      .focus();
  });
});
